<!-- Modern customers move between channels without thinking about it. With Yabbr Web Chat, your team doesn’t have to think about it either. Every SMS, MMS, Email, Voice, and Web Chat message appears in one unified conversation thread. With intelligent routing, auto-translation, and CRM integration, agents can respond faster, smarter, and in context. -->
 
<template>
    <ChannelsGeneral title="Web Chat">
        <template #content>
            <p>
                Modern customers move between channels without thinking about it. With Yabbr Web Chat, your team doesn’t have to think about it either. 
                <br><br>
                Every <b>SMS, MMS, Email, Voice, and Web Chat</b> message appears in one unified conversation thread. With <b>intelligent routing, auto-translation, and CRM integration</b>, agents can respond faster, smarter, and in context.
            </p>
            <v-btn
                class="btn-primary--outline rounded-pill mt-8"
                outlined
                large
                :ripple="false"
                href="/chat"
                >
                Yabbr Chat
                    <v-icon>mdi-arrow-right-thin</v-icon>
                </v-btn>
        </template>
        <template #img>
            <v-img
            src="../assets/img/chat-inbox.png"
            max-width="500px"
            alt="Chat inbox"
            contain />
        </template>
    </ChannelsGeneral>
</template>

<script>
import ChannelsGeneral from './ChannelsGeneral.vue'

export default {
    name: 'ChannelsChat',
    components: {
    ChannelsGeneral
    }
}
</script>

<style lang="scss">
</style>